export type RetryWindow = { floor: number; ceiling: number; growth: number }

export const RETRY: RetryWindow = { floor: 1_000, ceiling: 30_000, growth: 2 }

export const jitteredDelay = (attempt: number, window: RetryWindow, roll: number): number => {
  const reach = Math.min(window.ceiling, window.floor * window.growth ** Math.max(0, attempt - 1))

  return Math.round(window.floor + roll * (reach - window.floor))
}
